import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { RentalAgreementsReminderOptions } from '../types/rental-agreements-reminder-options';
import { VehicleInsurancesReminderOptions } from '../types/vehicle-insurances-reminder-options';
import { VehicleRoadTaxesReminderOptions } from '../types/vehicle-road-taxes-reminder-options';
import { VehicleRoadWorthyChecksReminderOptions } from '../types/vehicle-road-worthy-checks-reminder-options';

/**
 * Reminder preferences DTO
 */
@CaslSubject(AppSubjectEnum.REMINDER_PREFERENCES)
export class ReminderPreferencesDto extends BaseDto {
	/**
	 * Id of the user for whom the reminder preferences are defined.
	 */
	userId!: number;

	/**
	 * Flag indicating if reminders are enabled
	 * @description If false, no reminders will be sent regardless of other settings.
	 */
	enabled!: boolean;

	/**
	 * Reminder options for Rental Agreements module
	 */
	rentalAgreements?: RentalAgreementsReminderOptions;

	/**
	 * Reminder options for Vehicle Insurances module
	 */
	vehicleInsurances?: VehicleInsurancesReminderOptions;

	/**
	 * Reminder options for Vehicle Road Taxes module
	 */
	vehicleRoadTaxes?: VehicleRoadTaxesReminderOptions;

	/**
	 * Reminder options for Vehicle Road Worthy Checks module
	 */
	vehicleRoadWorthyChecks?: VehicleRoadWorthyChecksReminderOptions;
}
